module.exports = __webpack_public_path__ + "img/no-data-duo-icon.37ff1fe3.svg";